import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { colors } from '~/styles/colors';

export const ContainerHistoryControl = styled.div`
  h1 {
    font-size: 20px;
  }
`;

export const HeaderHistoryControl = styled.div`
  margin: 20px 0;
  display: flex;
  align-items: center;
  gap: 10px;
  h1 {
    margin: 0;
  }
`;

export const FilterContainer = styled.div`
  font-size: 20px;

`;

export const Scroll = styled.div`
  @media (max-width: 1137px) {
     overflow-x: auto;
    overflow-y: hidden;
    white-space: nowrap;
  }
`;

export const ButtonExport = styled.button`
  color: ${colors.BlueSecondary};
  border: 1px solid ${colors.BlueSecondary};
  border-radius: 4px;
  background-color: ${colors.White};
  padding: 0 12px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: 33px;
  font-weight: 600;
  gap: 6px;
  &:hover {
    cursor: pointer;
    background-color: ${colors.Blue050};
    border: 1px solid transparent;
  }
`;

export const StyledLink = styled(Link)`
  color: black;
  font-family: Inter, sans-serif;
  font-style: normal;
  font-weight: 400;
  text-decoration: underline;
`;
